var exports = {
  "X": "Scroller.module__scroller___c0RXdX",
};

module.exports = exports;
